export const VendorType = {
  amadeus: 0,
  pyton: 1,
  drifters: 2,
  tourplan: 3,
  wetu: 4,
  expedia: 5,
  tui: 6,
  juniper: 7,
  arabianAdventures: 8,
  hotelbeds: 9,
  xs2Events: 10,
  zeus: 11,
  koediaHermes: 12,
  dianaTravel: 13,
  asianTrail: 14,
  viator: 15,
  newWorldTravel: 16,
  airGateway: 17,
  goldenRingHotel: 18,
  restel: 19,
  goldenRingFlight: 21,
  sunnyCars: 20,
};
